import "preact/debug";
import "virtual:uno.css";
import "react-datepicker/dist/react-datepicker.css";

import sodium from "libsodium-wrappers-sumo";
import { render } from "preact";
import {
  Route,
  BrowserRouter as Router,
  Routes,
  useNavigate,
} from "react-router-dom";

// Components //////////////////////////////////////////////////////////////////
import { GlobalLayout } from "./components/layouts/global";
import { RequireLogin } from "./components/util/requireLogin";
import { WithOriginalContext } from "./context";

// (Old) Components ////////////////////////////////////////////////////////////
// These are the original components from the React version of the site.
import { EmergencyExitButton } from "./src/components/EmergencyExitButton";
import CreateEntryLayout from "./src/components/layout/CreateEntryLayout";
import CreateIncidentLogLayout from "./src/components/layout/CreateIncidentLogLayout";
import EditEntryLayout from "./src/components/layout/EditEntryLayout";
import MainLayout from "./src/components/layout/MainLayout";
import OrfEditLayout from "./src/components/layout/OrfEditLayout";
import PublicLayout from "./src/components/layout/PublicLayout";
import { PrivateRoutes, PublicRoutes } from "./src/config/routes";
import AccountSettings from "./src/containers/AccountSettings";
import { AnswerSecurityQuestions } from "./src/containers/AnswerSecurityQuestions";
import ConsentDashboard from "./src/containers/ConsentDashboard";
import ContactInfo from "./src/containers/ContactInfo";
import CreateWhere from "./src/containers/CreateWhere";
import CreateWho from "./src/containers/CreateWho";
import SelectSocialMedia from "./src/containers/CreateWho/SelectSocialMedia";
import SocialAccounts from "./src/containers/CreateWho/SocialAccounts";
import { Demographics } from "./src/containers/Demographics";
import EditEntry from "./src/containers/EditEntry";
import Feedback from "./src/containers/Feedback";
import IncidentLogPage from "./src/containers/IncidentLog/IncidentLogPage";
import { IncidentLogSummaryPage } from "./src/containers/IncidentLog/IncidentLogSummaryPage";
import { IncidentLogDashboard } from "./src/containers/IncidentLogDashboard";
import { IncidentLogPdf } from "./src/containers/IncidentLogPdf/IncidentLogPdf";
import { MainDashboard } from "./src/containers/MainDashboard";
import MatchingSystemDashboard from "./src/containers/MatchingSystem";
import NotFoundPage from "./src/containers/NotFoundPage";
import OrfConsent from "./src/containers/OrfConsent";
import OrfEvidence from "./src/containers/OrfEvidence";
import OrfIncidents from "./src/containers/OrfIncidents";
import OrfIntro from "./src/containers/OrfIntro";
import OrfKnow from "./src/containers/OrfKnow";
import OrfOffenders from "./src/containers/OrfOffenders";
import { OrfPdf } from "./src/containers/OrfPdf";
import OrfReview from "./src/containers/OrfReview";
import OrfWhen from "./src/containers/OrfWhen";
import OrfWhere from "./src/containers/OrfWhere";
import { RecoverAccountToken } from "./src/containers/RecoverAccountToken";
import { RecoveryEmailEntry } from "./src/containers/RecoveryEmailEntry";
import { RecoverySetup } from "./src/containers/RecoverySetup";
import { RequestAccountRecovery } from "./src/containers/RequestAccountRecovery";
import ResetNew from "./src/containers/ResetNew";
import ResetPassword from "./src/containers/ResetPassword";
import { Resources } from "./src/containers/Resources";
import SubmitForm from "./src/containers/SubmitForm";
import { VerifyRecoveryEmail } from "./src/containers/VerifyRecoveryEmail";
import { VerifyRecoveryEmailToken } from "./src/containers/VerifyRecoveryEmailToken";

// New Components //////////////////////////////////////////////////////////////
import "./pages/signup/index.solid";
import "./pages/login.solid";
import "./pages/dashboard.solid";
import "./components/bugReport.solid";
import { bootstrapFeatureFlags, globalState } from "./state";

// Routes //////////////////////////////////////////////////////////////////////
// TODO: import the routes from Admin/DLOC/LOC apps into here
function AppRoutes() {
  const navigate = useNavigate();

  return (
    <Routes>
      <Route element={<GlobalLayout />}>
        <Route element={<PublicLayout />}>
          <Route
            path={PublicRoutes.LOGIN}
            element={
              <login-new-experience
                finish={() => {
                  navigate(PrivateRoutes.DASHBOARD);
                }}
              />
            }
          />
          <Route
            path={PublicRoutes.RESET_PASSWORD}
            element={<ResetPassword />}
          />
          <Route
            path={PublicRoutes.RESET_PASSWORD_NEW}
            element={<ResetNew />}
          />
          <Route path={PublicRoutes.FEEDBACK} element={<Feedback />} />
          <Route
            path={PublicRoutes.RECOVERY_EMAIL_ADDRESS}
            element={<RecoveryEmailEntry />}
          />
          <Route
            path={PublicRoutes.RECOVER_ACCOUNT_TOKEN}
            element={<RecoverAccountToken />}
          />
          <Route
            path={PublicRoutes.ANSWER_SECURITY_QUESTIONS}
            element={<AnswerSecurityQuestions />}
          />
          <Route
            path={PublicRoutes.VERIFY_RECOVERY_EMAIL_TOKEN}
            element={<VerifyRecoveryEmailToken />}
          />
          <Route
            path={PublicRoutes.VERIFY_RECOVERY_EMAIL}
            element={<VerifyRecoveryEmail />}
          />
          <Route
            path={PublicRoutes.REQUEST_ACCOUNT_RECOVERY}
            element={<RequestAccountRecovery />}
          />
        </Route>
        <Route element={<RequireLogin />}>
          <Route path={PrivateRoutes.DEMOGRAPHICS} element={<Demographics />} />
          <Route
            path={PrivateRoutes.RECOVERY_SETUP}
            element={<RecoverySetup />}
          />
          <Route element={<MainLayout />}>
            <Route path={PrivateRoutes.DASHBOARD} element={<MainDashboard />} />
            <Route
              path={PrivateRoutes.MATCHING_SYSTEM}
              element={<MatchingSystemDashboard />}
            />
            <Route
              path={PrivateRoutes.ILOG}
              element={<IncidentLogDashboard />}
            />
            <Route
              path={PrivateRoutes.CONSENT_SETTINGS}
              element={<ConsentDashboard />}
            />
            <Route path={PrivateRoutes.ACCOUNT} element={<AccountSettings />} />
            <Route path={PrivateRoutes.CONTACT_US} element={<Feedback />} />
            <Route path={PrivateRoutes.RESOURCES} element={<Resources />} />
          </Route>
          <Route element={<CreateEntryLayout />}>
            <Route
              path={PrivateRoutes.CREATE_WHERE}
              element={<CreateWhere />}
            />
            <Route path={PrivateRoutes.CREATE_WHO} element={<CreateWho />}>
              <Route
                path={PrivateRoutes.CREATE_WHO}
                element={<SelectSocialMedia />}
              />
              <Route
                path={PrivateRoutes.CREATE_WHO_SOCIAL}
                element={<SocialAccounts />}
              />
            </Route>
            <Route
              path={PrivateRoutes.CREATE_CONTACT}
              element={<ContactInfo />}
            />
            <Route
              path={PrivateRoutes.CREATE_SUBMIT}
              element={<SubmitForm />}
            />
          </Route>
          <Route element={<EditEntryLayout />}>
            <Route path={PrivateRoutes.ENTRIES_EDIT} element={<EditEntry />} />
          </Route>
          <Route element={<CreateIncidentLogLayout />}>
            <Route
              path={PrivateRoutes.ILOG_WHO_WHAT}
              element={<IncidentLogPage stepName="whoWhat" />}
            />
            <Route
              path={PrivateRoutes.ILOG_WHEN}
              element={<IncidentLogPage stepName="when" />}
            />
            <Route
              path={PrivateRoutes.ILOG_WHERE}
              element={<IncidentLogPage stepName="where" />}
            />
            <Route
              path={PrivateRoutes.ILOG_PEOPLE}
              element={<IncidentLogPage stepName="people" />}
            />
            <Route
              path={PrivateRoutes.ILOG_CONSENT}
              element={<IncidentLogPage stepName="consent" />}
            />
            <Route
              path={PrivateRoutes.ILOG_INCIDENT}
              element={<IncidentLogPage stepName="incident" />}
            />
            <Route
              path={PrivateRoutes.ILOG_OFFENDERS}
              element={<IncidentLogPage stepName="offenders" />}
            />
            <Route
              path={PrivateRoutes.ILOG_EVIDENCE}
              element={<IncidentLogPage stepName="evidence" />}
            />
            <Route
              path={PrivateRoutes.ILOG_NOTES}
              element={<IncidentLogPage stepName="notes" />}
            />
            <Route
              path={PrivateRoutes.ILOG_SUMMARY}
              element={<IncidentLogSummaryPage />}
            />
            <Route
              path={PrivateRoutes.ILOG_PDF_DOWNLOAD}
              element={<IncidentLogPdf />}
            />
          </Route>
          <Route element={<OrfEditLayout />}>
            <Route path={PrivateRoutes.ORF_INTRO} element={<OrfIntro />} />
            <Route path={PrivateRoutes.ORF_WHEN} element={<OrfWhen />} />
            <Route path={PrivateRoutes.ORF_WHERE} element={<OrfWhere />} />
            <Route path={PrivateRoutes.ORF_KNOW} element={<OrfKnow />} />
            <Route path={PrivateRoutes.ORF_CONSENT} element={<OrfConsent />} />
            <Route
              path={PrivateRoutes.ORF_INCIDENTS}
              element={<OrfIncidents />}
            />
            <Route
              path={PrivateRoutes.ORF_OFFENDERS}
              element={<OrfOffenders />}
            />
            <Route
              path={PrivateRoutes.ORF_EVIDENCE}
              element={<OrfEvidence />}
            />
            <Route path={PrivateRoutes.ORF_REVIEW} element={<OrfReview />} />
            <Route path={PrivateRoutes.ORF_PDF_DOWNLOAD} element={<OrfPdf />} />
          </Route>
        </Route>
        <Route
          path="/"
          element={<RequireLogin redirect={PrivateRoutes.DASHBOARD} />}
        />
        <Route path="*" element={<NotFoundPage />} />
      </Route>
    </Routes>
  );
}

function App() {
  return (
    <Router>
      <WithOriginalContext>
        <EmergencyExitButton />
        <bug-report-button />
        <AppRoutes />
      </WithOriginalContext>
    </Router>
  );
}

(async () => {
  await sodium.ready;
  await globalState.client.ready;
  await bootstrapFeatureFlags();

  // TODO: render to the <body> instead for simplicity?
  // biome-ignore lint/style/noNonNullAssertion: I'm pretty sure this element will exist.
  render(<App />, document.getElementById("root")!);
})();
